// extracted by mini-css-extract-plugin
export default {"Services":"services_Services__v3qua","ServicesList":"services_ServicesList__oCHtV","ServiceItem":"services_ServiceItem__73EF7"};